import { createV3Queries } from "@query/utils/createV3Queries";
import { insuranceMonitorsApi } from "@api";
import { getRequirementsDependencies } from "../../modules/Requirements/dependencies";

/**
 * Insurance-monitor registry — mirrors `InsuranceMonitorsApi` 1:1
 * (`/v3/compliance/insurance-monitors`). Monitors back `InsuranceCoverage`
 * requirement instances (matching a coverage to a monitor completes the
 * requirement), so monitor writes fan out into the requirement reads.
 */
export const queriesInsuranceMonitors = createV3Queries(
  "insuranceMonitorsApi",
  insuranceMonitorsApi,
  {
    createInsuranceMonitor: () => ({
      dependencies: () => getRequirementsDependencies()
    }),
    updateInsuranceMonitor: () => ({
      dependencies: () => getRequirementsDependencies()
    })
  }
);
